import { JobPointeSearchParams } from 'src/app/shared/models/jobPointeSearchParams';

export enum AssignmentGroups {
  AssignedToEmployee = 'Assigned to employee',
  Other = 'Other',
}
export interface JobModel {
  id?: number;
  name: string;
  potentialJobDetail?: object;
}

export interface AutoCompleteSelectModel {
  item: any;
  id: string;
}

export interface OwnerModel {
  id?: number;
  ownerName: string;
}

export interface FacilityModel {
  id?: number;
  facilityName: string;
}

export interface UserModel {
  id?: number;
  employeeAlias: string;
}

export interface AssignmentTypeModel {
  id?: number;
  name: string;
  group: string;
}

export interface AssignmentModel {
  type: AssignmentTypeModel;
  primaryAssignment: string;
}

export interface SelectedDataModel {
  id: number | string;
  toolId: number;
  description: string;
  assignment?: Array<AssignmentModel>;
  selected?: boolean;
}

export interface PaginationModel {
  currentPage: number;
  totalPages: number;
  nextPage: number;
}

export interface ResponseModel {
  data: any;
  pagination: PaginationModel;
}

export interface TransferModel {
  toolId: number;
  assignedDate: string;
  typeId?: number;
  jobId?: number;
  ownerId?: number;
  facilityId?: number;
  responsiblePartyId?: number;
  employeeId?: number;
  vendorId?: number;
  shopId?: number;
  notes?: string;
}

export interface TransferModelData {
  key: string;
  value: string | number;
}

export const JobParams: JobPointeSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,jobNumber,name',
  embed: 'potentialJobDetail',
  order: 'jobNumber,DESC',
};

export const ParamsMappingForTransfer = [
  {
    name: 'jobs',
    param: JobParams,
  },
];
